/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import '../../tBillRates/Components/tBillTabelHead.css';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';

const filterParams = {
  browserDatePicker: true,
  minValidYear: 2000,
};
const rx_live = /^\d\.\d{6}$/;
export var errorMessages1 = [];
export var errorMessages2 = [];
function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);

  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }

  return date1Number - date2Number;
}

export const tBillTableHead = [
  {
    headerName: 'Effective Date',
    field: 'effectiveDateWithoutTime',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    sort: 'desc',
    suppressMenu: false,
    minWidth: Styles.Width_150,
    width: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Rate',
    field: 'tbillRate',
    editable: false,
    suppressMenu: false,
    sortable: true,
    exportZeroesSix: true,
    resizable: false,
    excelAlignment: 'right',
    minWidth: Styles.Width_600,
    cellRenderer: 'TextBoxRender',
    cellStyle: { textAlign: 'right' },
    cellEditorParams: {
      maxLength: 8,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const postSortRows = (params) => {
  const rowNodes = params.nodes;
  let nextInsertPos = 0;
  for (let i = 0; i < rowNodes.length; i++) {
    if (
      !rowNodes[i].data.lastUpdateDt ||
      rowNodes[i].data.lastUpdateDt === ''
    ) {
      rowNodes.splice(nextInsertPos, 0, rowNodes.splice(i, 1)[0]);
      nextInsertPos++;
    }
  }
};
